import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from "@angular/platform-browser/animations";
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideToastr } from 'ngx-toastr';
import { JwtInterceptor } from '../Utils/_interceptors/jwt.interceptor';
import { ErrorInterceptor } from '../Utils/_interceptors/error.interceptor';
import { providePrimeNG } from 'primeng/config';
import Lara from "@primeuix/themes/lara";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([
      JwtInterceptor,
      ErrorInterceptor
    ])),
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          prefix: "p",
          darkModeSelector: false,
          cssLayer: false,
        },
      },
    }),
    provideAnimations(),
    provideToastr()
  ],
};
